import React, { useCallback } from 'react';
import DropdownV3 from '@zola/zola-ui/src/components/Form/dropdownV3';
import { SingleFilterUpdate } from 'cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterTypes';
import {
  SORT_DEFAULT,
  SORT_DEFAULT_LABEL,
  SORT_OPTIONS,
  SORT_OPTIONS_DIGITAL,
} from 'cards/components/CardListing/CardListingRedesign/constants';

import styles from './styles.module.less';
import { FilterChip } from '../CardListingFilter/FilterStyles.styles';

type SortByType = {
  handleFilterUpdate: SingleFilterUpdate;
  sortBy: string[];
  isDigital?: boolean;
};

const SortBy = ({ handleFilterUpdate, sortBy, isDigital }: SortByType): JSX.Element => {
  const selectedValue = sortBy?.[0] || SORT_DEFAULT;
  const handleSortBy = useCallback(
    (value: string) => {
      handleFilterUpdate('sorts', value === SORT_DEFAULT ? [] : [value]);
    },
    [handleFilterUpdate]
  );

  return (
    <DropdownV3
      options={isDigital ? SORT_OPTIONS_DIGITAL : SORT_OPTIONS}
      value={selectedValue}
      onSelect={handleSortBy}
      className={styles.sortByDropdown}
      id="sort-by"
      trigger={
        <FilterChip withCaret>
          Sort: {SORT_OPTIONS.find(s => s.value === selectedValue)?.label || SORT_DEFAULT_LABEL}
        </FilterChip>
      }
    />
  );
};

export default SortBy;
